import React, { useContext, useEffect } from "react";
import { Helmet } from "react-helmet";
import { observer } from "mobx-react";

import "./style.scss";
import { ArticleLayout, ArticleNav } from "../../components/shared/index";
// import loadingGif from "../../images/nextpage-loading.gif";
import HomeList from "./HomeList";
import bookImg from "../../images/book.png";
import lookImg from "../../images/book-lock.png";
import authStore from "../../stores/authStore";
import articleStore from "../../stores/articleStore";
import { isMobile } from "../../utils/tools";
// import authStore from "../../stores/authStore";
// import { MODEL_AUTH } from "../../constants/model_auth";

const Home: React.FC = () => {
  const { isLogin, isMember } = useContext(authStore);
  const { setOpenName, elapsedDays, articlesCount } = useContext(articleStore);
  // const { isCurrentUserEmpty, currentUser } = useContext(authStore);

  useEffect(() => {
    window.sessionStorage.removeItem("articlePath");
  }, []);

  return (
    <div className="home" onClick={() => setOpenName("")}>
      <Helmet>
        <title>文章库 ｜ 机器之心</title>
      </Helmet>
      <ArticleLayout>
        <ArticleNav
        // refreshFn={() => {
        //   fetchMemberInfo();
        //   fetchList(true);
        // }}
        />
        <div className="home__content">
          <HomeList />
          {!isMobile() && (
            <div className="home__blank">
              <div>
                <img src={isLogin && isMember ? bookImg : lookImg} alt="book" />
                <p>
                  已追踪 AI 发展 <span>{elapsedDays}</span> 天，
                  <span>{articlesCount}</span> 篇原创内容
                </p>
              </div>
              <p className="home__tips">任何关于订阅和使用的疑问, 请联系客服
                <span>support@jiqizhixin.com</span>
              </p>
            </div>
          )}
        </div>
      </ArticleLayout>
    </div>
  );
};

export default observer(Home);
